import codes from '@/codes';
import reg from '@/reg';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import moment from 'moment-timezone';

// another vue
import groupList from '../../group/group.List.i18n'
import partnerList from '../partner.List.i18n'
import logLoginList from '../../../Log/login/login.Partner.List.i18n'
import logActionList from '../../../Log/action/action.Partner.List.i18n'
import SettingService from  '../../../System/setting/setting.Service.i18n'
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy

// invoice
import InvoicePartnerList from '../../../Billing/invoice.partner/invoice.partner.List.i18n'
import VueMonthlyPicker from 'vue-monthly-picker'

//restful api
import { partner as manager } from '@/service/api/manager'
import { partner as billing } from '@/service/api/billing'
import { license, price } from '@/service/api/billing'
import { credit as history } from '@/service/api/history'

import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import custom from '@/custom';

const default_model = () => (
  { is_alive : true, permissions : 'Owner', is_del : false, parent_id : null, parent_username : '', tax : 0.00, allow_invoice : false }
);

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

const i18n_pay = {
  EN: [
    { key: 'service.name', label: 'Service', sortable: false  },
    { key: 'is_publish', label: 'Publish Status', sortable: false  },
    { key: 'service.min_price', label: 'F1 Cost price(*)', sortable: false  },
    { key: 'customer_price', label: 'List price(To Partner)=A+B', sortable: false  },
    { key: 'benefit.f1', label: "F1's Benefit(A)", sortable: false  },
    { key: 'benefit.partner', label: "Partner's Benefit(B)", sortable: false  },
    { key: 'func', label: "Manage", sortable: false  },
  ],
  KO: [
    { key: 'service.name', label: '서비스', sortable: false  },
    { key: 'is_publish', label: '공개 여부', sortable: false  },
    { key: 'service.min_price', label: 'F1 비용(*)', sortable: false  },
    { key: 'customer_price', label: 'List price(To Partner)=A+B', sortable: false  },
    { key: 'benefit.f1', label: "F1의 이익(A)", sortable: false  },
    { key: 'benefit.partner', label: "파트너의 이익(B)", sortable: false  },
    { key: 'func', label: "관리", sortable: false  },
  ]
}

const i18n_history = {
  EN: [
    { key: 'created_at', label: 'Date', sortable: false  },
    { key: 'credit_amount', label: 'Amount', sortable: false  },
    { key: 'credit_info.from', label: 'From', sortable: false  },
    { key: 'credit_info.to', label: 'To', sortable: false  },
    { key: 'credit_info.to_credit', label: 'To-Credit', sortable: false  },
    { key: 'credit_info.invoice_id', label: 'Invoices', sortable: false  },
    { key: 'credit_info.reason', label: 'Credit Log', sortable: false  },
  ],
  KO: [
    { key: 'created_at', label: '생성일', sortable: false  },
    { key: 'credit_amount', label: '합계', sortable: false  },
    { key: 'credit_info.from', label: '보낸 사람', sortable: false  },
    { key: 'credit_info.to', label: '받는 사람', sortable: false  },
    { key: 'credit_info.to_credit', label: '신용거래 내역', sortable: false  },
    { key: 'credit_info.invoice_id', label: '청구서', sortable: false  },
    { key: 'credit_info.reason', label: '신용 거래 로그', sortable: false  },
  ]
}

export default {
  props : ["partner"],
  watch: {
    '$route' (to, from) { this.get(to.params, "from", from); },
    partner() {
      console.log("watch updated props data")
      this.model = this.partner
      let is_done_country = false;
      codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

      let is_done_language = false;
      codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

      let is_done_timezone = false;
      codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });
    }
  },
  components: {
    VueMonthlyPicker,
    InvoicePartnerList,
    PictureInput,
    cSwitch,
    vSelect,
    groupList,
    logLoginList,
    logActionList,
    partnerList,
    SettingService,
    DatePicker,
  },
  data : () => {
		return {
      ticket_invoice_month : '',
      confirm_ticket_invoice : false,
      logo : '',
      publish_list : [],
      published_list : [],
      new_service_id : 0,
      service_append_confirm : false,
      mail_confirm : false,
      is_registed : false,
      index : 0,
      credit_history_opt : default_opt(),
      Credit_Add : false,
      credit_history_modal : false,
      Credit_History : undefined,
      amount : 0.00,
      amount_log : '',
      setting_modify_confirm : false,
      setting_modify : false,
      setting_modify_index : -1,
      partner_price : [],
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : Object.assign({}, default_model()),
      allowed: false,
      partner_connect_modal : false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
      published : false,
      custom,
      datepicker
    }
  },
  computed: {
    check_owner() {
      return this.model && this.model.permissions && (this.model.permissions || '').toLowerCase() == 'owner'
    },
    pay() {
      return i18n_pay[this.i18n];
    },
    history() {
      return i18n_history[this.i18n];
    }
  },
  methods: {
    //ip reset
    async send_ip_reset_mail() {
      let rs = await manager.ipPartner({ id : this.model.id });
      return rs.is_error ? this.$toastr.e("Sending IP ACL Reset Mail", "failed") : this.$toastr.s("IP ACL Reset Mail", "Sented");
    },
    // 매니저의 강제 인보이스 발급
    ticket_invoice() {
      if(moment(this.ticket_invoice_month).add(-1, 'month').diff(moment(), 'month') >= 0) {
        return this.$toastr.w("Future cannot issue invoice")
      } else if(!this.ticket_invoice_month) {
        return this.$toastr.w("plz, select date")
      }

      let month_format = moment(this.ticket_invoice_month).format("yyyy-MM-DD")

      // console.log(moment(this.ticket_invoice_month).format("yyyy-MM-DD"))
      // console.log("check : ", this.ticket_invoice_month.format("yyyy-MM-DD"))
      let body = {
        partner_id : this.model.id,
        // month : this.ticket_invoice_month.format("yyyy-MM-DD")
        month : month_format
      }

      return billing.ticketPartner(body)
        .then(rs => {
          if(rs.error) { return this.$toastr.w("failed ticket invoice") }
          this.$refs._list_invoice ? this.$refs._list_invoice.refresh() : ''
          // this.$emit('refresh')
          rs.error ? this.$toastr.w("failed ticket invoice") : this.$toastr.i("created invoice")
        })
        .catch(e => {console.log(e);  this.$toastr.e(e.data ? e.data : e.statusText)});
    },
    logo_change (image) {
      console.log('New picture selected!')
      if (image) {
        console.log('Picture loaded.', image)
        this.logo = image
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
    },
    toggle_publish_service(value, id) {
      if(this.published_list.indexOf(id) > -1) { console.log('already published', id); return }

      if(value) {
        console.log(id)
        this.publish_list.push(id)
        this.publish_list = _.uniqBy(this.publish_list)
      } else {
        this.publish_list = _.compact(_.filter(this.publish_list, x => x != id))
      }
    },
    async service_append(item) {
      try {
        //Todo : 베이직 서비스 선택시 그 서비스로 적용 후 진행이 되는지 확인해봐야되는 부분
        // item 선택시 제대로 id 를 가져오지만 그 후 inset 를 시도하면 partner already service error 가 발생
        // item 선택시 id 를 가져오지않으면 if절에 걸림
        this.new_service_id = item;
        if(this.new_service_id < 1) { return this.$toastr.w("plz, select service") }
        
        // new_service_id 는 베이직 서비스
        // let rs = await Api.Manager_Call('partner', 'insert.service', Object.assign({}, { partner_id : this.model.id, new_service_id : this.new_service_id }));
        let rs = await manager.servicePartner(Object.assign({}, { partner_id : this.model.id, new_service_id : this.new_service_id }));
        if(!rs.error) {
          this.$toastr.s('Successfully applied', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
          this.service_append_confirm = false
        } else {
          this.$toastr.e('Failed to applied, please try again later');
        }
        //Todo : error msg 발생시 e.data 인지 e.data.message 인지 구별해서 meg 보여줘야함
      } catch(e) { console.log("e : ", e); console.log("error data : ", e.data); console.log("msg : ", e.data.messgae); console.log("statusText : ", e.statusText); this.$toastr.e(e ? e.data ? e.data : e : e.data.statusText) }
    },
    async send_mail() {
      // 초대 메일 발송
      try {
        // let rs = await Api.Manager_Call('partner', 'insert.invite', Object.assign({}, { partner_id : this.model.id, url : location.hostname == 'localhost' ? 'https://partner.f1secaas.net/#/auth/reset' : `${location.protocol}//${location.host.replace('manager', 'partner')}//#/auth/reset` }));
        let rs = await manager.invitePartner(Object.assign({}, { partner_id : this.model.id, url : location.hostname == 'localhost' ? 'https://partner.f1secaas.net/#/auth/reset' : `${location.protocol}//${location.host.replace('manager', 'partner')}//#/auth/reset` }));
        if(!rs.error) {
          this.$toastr.s('Successfully sent mail', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
          this.mail_confirm = false
        } else {
          this.$toastr.e('Failed to send mail, please try again later');
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async setting_publish() {
      try {
        let rs = await license.publishLicense(Object.assign({}, { partner_id : this.model.id, service_list : this.publish_list }));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
          this.published = true
          this.mail_confirm = true
          this.publish_list = [] // 초기화
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    change_username(value) {
      this.model = Object.assign({}, this.model, { nickname : value.indexOf('@') > -1 ? value.split('@')[0] : value })
    },
    reload() {
      if(!this.model.parent_id || this.model.parent_id == this.model.id) { return this.$toastr.w("already owner selected") }
      this.$router.push({ name: 'partner', params : { id : this.model.parent_id } }); this.$toastr.i("refresh"); this.$emit('refresh') },
    select_partner(item) { console.log(item.partner.id); this.model = Object.assign({}, this.model, { parent_id : item.partner.id, parent_username : item.partner.username }); this.partner_connect_modal = false; },
    getRowCount() { return this.credit_history_opt && this.credit_history_opt.totalRows || 0; },
    async credit_control(){
      try {
        if(this.amount == 0) { return this.$toastr.w('Number is Zero'); }

        let cmd = this.amount < 0

        if(cmd == true){
          let rs = await manager.minusCredit({ partner_id : this.model.id, amount : this.amount, reason : this.amount_log  });

          if(rs.error) {return this.$toastr.e("credit control failed", this.$route.name) }

          if(this.$refs._list_credit_history) { this.$refs._list_credit_history.refresh(); }
        }else{
          let rs = await manager.plusCredit({ partner_id : this.model.id, amount : this.amount, reason : this.amount_log  });

          if(rs.error) {return this.$toastr.e("credit control failed", this.$route.name) }

          if(this.$refs._list_credit_history) { this.$refs._list_credit_history.refresh(); }
        }

        this.model.credit = Number(this.model.credit) + Number(this.amount);
        this.$toastr.i('Success!');

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    //비밀번호 reset
    async send_password_reset_mail() {
      let rs = await manager.resetPartner({ id : this.model.id });
      return rs.is_error ? this.$toastr.e("sending Password Reset Mail", "failed") : this.$toastr.s("Password Reset Mail", "Sented");
    },
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.new_password && reg.reg_number.test(this.model.new_password) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.new_password && reg.reg_alphabat_upper.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.new_password && reg.reg_alphabat_lower.test(this.model.new_password) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.new_password && reg.reg_spacial.test(this.model.new_password) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.new_password && this.model.new_password.length >= 10) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    cancel: function() { if(this.$route.params.id == "add") { this.list(); } this.lock = true },
    async remove() {
      try {
        let rs  = await manager.deletePartner({id : this.model.id});
        if(!rs.error) {
          this.$toastr.s('Removed'); this.list();
        } else {
          this.$toastr.e('delete', "failed"); this.cancel();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    list() { this.$router.push({ name: 'partner'}); this.$emit('refresh'); },
    refresh(id) {
      this.$router.push({ name: 'partner', params : { id : id ? id : this.$route.params.id } });
    },
    edit:function() { this.lock = false },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_language:function(x) { if(!x) { return; } console.log(x, 'sss'); this.model.language = x.value  },
    async price_save(row) {

      let model = {
        partner_id : this.model.id,
        service_id : row.service.id,
        partner_price : parseFloat(row.partner_price),
        // base_price : parseFloat(row.base_price),
        customer_price : parseFloat(row.customer_price), // 파트너의 공개 가격(f1's benefit + partner's benefit)
        service_name : row.service_name,
      }
      console.log('model', model)

      // check validation
      // 편이사님이 제공 가격도 수정을 요청
      // if(row.service.min_price > model.list_price ) { return this.$toastr.e("Can't provide price", "f1 benefit is over Cost price") }

      try {
        // let rs = await Api.Manager_Call('partner.price', 'update.price', Object.assign({}, model));
        let rs = await price.updatePrice(Object.assign({}, model, { id : row.id }));
        // let rs = await license.updateLicense(Object.assign({}, model, { id : row.id }));
        if(rs.error) { this.$toastr.e("price update failed") }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      try {
        // let rs = await Api.Manager_Call('partner.license', 'update', Object.assign({}, model, { id : row.id }));
        let rs = await license.updateLicense( Object.assign({}, model, { id : row.id }));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          if(this.$refs._list_price) { this.$refs._list_price.refresh(); }
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }

      this.setting_modify = false;
      this.setting_modify_index = -1;
    },
    async save() {

      let model = {}

      // check validation
      try {
        if(!(this.model.username || '').trim()) { return this.$toastr.e('Username(ID) Required.'); }
        // if(!this.model.id && !this.model.new_password) { return this.$toastr.e('Password Required.'); }
        if(this.model.new_password && this.model.new_password != this.model.new_password_repeat) { return this.$toastr.e('Password repeat do not match'); }
        if(!(this.model.nickname || '').trim()) { return this.$toastr.e('Nickname Required.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('Address Required.'); }
        if(this.model.new_password) {
          var rs = this.password_policy('all')
          if(rs.is_error) {
            var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
            return this.$toastr.e(`Please check password policy [${msg}]`);
          }
        }
      } catch (e) { console.log(e); return this.$toastr.e('check validation failed'); }
      // 같은 파트너 매핑
      if(this.partner) { this.model.parent = this.partner.id; }

      // build data for sending
      model = Object.assign({}, this.model, { permissions : codes.permissions_partner_value[this.model.permissions] })
      model.tax = parseFloat(this.model.tax).toFixed(2)


      // if(model.parent_id != model.id && model.permissions == codes.permissions_partner_value['Owner']) { return this.$toastr.w('partner group only has 1 owner') }
      if(model.new_password) { model.new_password = forge.sha256.create().update(model.new_password).digest().toHex(); }
      if(model.group && model.group.id) { model.group_id = model.group.id; }
      if(this.model.allow_ip_list) {
        model.allow_ip = _.uniq(_.compact(this.model.allow_ip_list.replace(/,/gm, '').split("\n")));
        // b-form-textarea has bug, can not bind model so rirect update
        this.model.allow_ip_list = _.join(model.allow_ip, '\n')
        this.$refs.allow_ip_list.localValue = _.join(model.allow_ip, '\n')
      } else { model.allow_ip = "" }

      // set logo
      model.logo = this.logo

      // set region
      if(!this.region.country) { return this.$toastr.e('Country Required.'); }
      if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
      if(!this.region.language) { return this.$toastr.e('Language Required.'); }

      let region = {};
      region.country = this.region.country.value
      region.language = this.region.language.value
      region.timezone = this.region.timezone.value

      delete model.group;

      try{
        let check_id = this.model.id ? `${await manager.updatePartner(Object.assign({}, model, region))}` : `${await manager.insertPartner(Object.assign({}, model, region))}`;

        let rs = check_id;

        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh;
          this.list();
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      }catch(e){
        this.$toastr.e(e ? e.data ? e.data : e : e.statusText), this.list();
      }
      this.lock = true;
    },
    async get_partner_service(ctx) {
      let partner_price_info = {
        // target : 'partner.license', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'partner_id', value : this.model.id, op : '='}, { name : 'is_del', value : false, op : '='}, { name : 'is_alive', value : true, op : '='}] }
      }
      if(ctx.sortBy) { partner_price_info.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      // let rs_service = await Api.Manager(partner_price_info)
      let rs_service = await license.listLicense(partner_price_info)
      this.published = false
      if(rs_service.error) { return this.$toastr.e("service price load failed", this.$route.name) }
      (rs_service.body || []).forEach(r => { if(r.is_publish == true) { this.published = true; this.published_list.push(r.id) } })
      return rs_service && rs_service.body  ? rs_service.body : []
    },
    async get_credit_list(ctx) { return await this.get_credit_info(ctx) },
    async get_credit_info(ctx) {
      console.log("model : ", this.model.id)
      let credit_history_opt = {
        // target : 'history.credit', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : [ { name : 'partner_id', value : this.model.id, op : '='} ]
        },
        offset : (this.credit_history_opt.currentPage-1 || 0) * Number(this.credit_history_opt.perPage), limit: Number(this.credit_history_opt.perPage),
      }

      if(ctx.sortBy) { credit_history_opt.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }

      // let rs = await Api.Manager(credit_history_opt)
      console.log("body : ", credit_history_opt.body)
      // let rs = await manager.creditPartner(credit_history_opt)
      let rs = await history.listCredit(credit_history_opt)
      if(rs.error) { return this.$toastr.e("load failed", this.$route.name) }

      this.credit_history_opt.totalRows = rs.total;
      return rs.body
    },
    async get({ id, tag } = this.$route.params) {
      this.model = default_model()

      console.log('partner.detail.vue', 'load item', id, tag);
      if((id === 'add' && (this.partner == false || this.$route.name == "partner"))) { this.add = true; this.lock = false; this.model.is_alive = true; return; }
      try{
        this.model.id = Number(id);
        this.add = false;
        if(this.partner) {
          this.model = this.partner;
        } else {
          // let rs = await Api.Manager_Call('partner', 'detail', { id : id })
          let rs = await manager.detailPartner({ id : id })
          if(rs.error) { return this.$toastr.e("load failed", this.$route.name); }
          this.model = Object.assign({ group: {} }, this.model, rs.body)
        }

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        // this.index = location.hostname == 'localhost' ? 3 : 0

        console.log(this.model.updated_at, this.model.created_at)

        if(this.model.permissions.toLowerCase() == 'owner') {
          this.is_registed = this.model.updated_at == this.model.created_at
        } else { console.log("this partner not owner, so price is lock") }

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('partner_Detail.vue', 'created'); },
  destroyed() { console.log('partner_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('partner_Detail.vue', 'mounted');
    this.get(this.$route.params);
    this.$root.$on('selected', this.select_partner);
    this.$root.$once('get_basic_service', this.service_append);
  },
}